import React, { Component } from "react"
import autobind from "class-autobind"
import { CircularProgress, FloatingActionButton, Table, TableBody, TableRow, TableRowColumn } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import { IScheduleShift, IClientDocument } from "../../../models"
import strings from "../../../localization/strings"
import TableActionBar from "../../../components/layout/TableActionBar"
import ShiftTemplatesTable from "../../schedules/shift-templates/ShiftTemplatesTable"
import AddShiftTemplateDialog from "../../../components/schedule/add_shift_template/AddShiftTemplateDialog"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import AppStateStore from "../../../stores/AppStateStore"
import * as AccountActions from "../../../actions/AccountActions"
import AccountStore from "../../../stores/AccountStore"
interface IProps {
    readonly: boolean
    client: IClientDocument
}

interface IState {
    shifts: IScheduleShift[]
    editShift: IScheduleShift
    selectedShifts: IScheduleShift[]
    startDate: string | Date
    endDate: string | Date
    searchText: string
    loading: boolean
    total: number
    offset: number
    limit: number
    openAddShiftDialog: boolean
}

export class ClientDetailsShifts extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            shifts: [],
            editShift: null,
            selectedShifts: [],
            startDate: null,
            endDate: null,
            searchText: "",
            loading: false,
            total: 0,
            offset: 0,
            limit: 20,
            openAddShiftDialog: false
        }
        autobind(this)
    }

    componentDidMount() {
        AccountStore.on("account_change", this.getShiftTemplates)
        this.getShiftTemplates()
    }

    getShiftTemplates() {
        this.setState({ loading: true }, () => {
            const shifts = AccountStore.getCurrentAccount()
                .ScheduleData.ShiftTemplates.filter((shift) => shift.ClientId === this.props.client.Id && !shift.Deleted)
                .sort((a, b) => {
                    if (a.Name < b.Name) return -1
                    if (a.Name > b.Name) return 1
                    return 0
                })

            this.setState({
                loading: false,
                shifts,
                selectedShifts: []
            })
        })
    }

    handleSelectedShifts(selectedShifts) {
        this.setState({ selectedShifts })
    }

    handleAdd(shiftTemplate: IScheduleShift) {
        this.setState({ openAddShiftDialog: false }, () => {
            AppStateStore.setProgressSnackbarContent("loading")
            AccountActions.addShiftTemplate(AccountStore.getCurrentAccount().Id, shiftTemplate, () => AppStateStore.setProgressSnackbarContent(strings.Shift_template_added_successfully))
        })
    }

    handleUpdate(shiftTemplate: IScheduleShift) {
        this.setState({ openAddShiftDialog: false, editShift: null }, () => {
            AppStateStore.setProgressSnackbarContent("loading")
            AccountActions.updateShiftTemplate(AccountStore.getCurrentAccount().Id, shiftTemplate, () => AppStateStore.setProgressSnackbarContent(strings.Shift_template_updated_successfully))
        })
    }

    handleDeleteShift() {
        AppStateStore.setProgressSnackbarContent("loading")
        AccountActions.deleteShiftTemplates(AccountStore.getCurrentAccount().Id, this.state.selectedShifts.map((x) => x.Id), () => {
            AppStateStore.setProgressSnackbarContent(strings.Shift_template_deleted_successfully)
        })
    }

    render() {
        return (
            <div className="detail-tab">
                <div style={{ position: "relative" }}>
                    {this.state.loading ?
                        <div className="spinner">
                            <CircularProgress />
                        </div> :
                        <div>
                            {!this.props.readonly &&
                                <FloatingActionButton
                                    className="fixed-add"
                                    style={{ position: "relative", float: "right", right: 50, top: -45, zIndex: 998 }}
                                    secondary={true}
                                    onTouchTap={() => this.setState({ openAddShiftDialog: true })}
                                >
                                    <ContentAdd />
                                </FloatingActionButton>
                            }
                            <TableActionBar
                                rowSelectionCount={this.state.selectedShifts.length}
                                singleSelectedMessage={strings.Shift_Template_Selected}
                                multipleSelectedMessage={strings.x_Shift_Templates_Selected}
                                title={strings.Shift_Templates}
                                onSearch={(searchText) => this.setState({ searchText, offset: 0 })}
                                reloadTable={this.getShiftTemplates}
                                searchText={""}
                                readonly={this.props.readonly}
                                onDeleteClick={() =>
                                    AppStateStore.setConfirmDialogContent({
                                        content: strings.Are_you_sure_you_want_to_delete_the_selected_shift,
                                        confirm: this.handleDeleteShift
                                    })
                                }
                            />
                            <div>
                                {!this.state.shifts.length ?
                                    <Table>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow>
                                                <TableRowColumn>
                                                    <h2 style={{ textAlign: "center", marginTop: 25 }}>{strings.No_shift_template_found}</h2>
                                                </TableRowColumn>
                                            </TableRow>
                                        </TableBody>
                                    </Table> :
                                    <ShiftTemplatesTable
                                        shiftTemplates={this.state.shifts}
                                        selectedShiftTemplates={this.state.selectedShifts}
                                        handleSelect={this.handleSelectedShifts}
                                        handleUpdate={editShift => this.setState({ openAddShiftDialog: true, editShift })}
                                    />
                                }
                                {this.state.openAddShiftDialog &&
                                    <AddShiftTemplateDialog
                                        isAccountTemplate
                                        editShiftTemplate={this.state.editShift}
                                        hierarchyId={HierarchySettingsStore.getGlobalLevelItemFilterId()}
                                        handleClose={() => this.setState({ openAddShiftDialog: false, editShift: null })}
                                        handleAdd={this.handleAdd}
                                        handleUpdate={this.handleUpdate}
                                        scheduleClient={this.props.client}
                                    />
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default ClientDetailsShifts
